/**
 * Откуда хост узнаёт про ремоуты.
 *
 * Файл лежит рядом со сборкой хоста и читается в рантайме, а не вшивается
 * на этапе компиляции. Смысл ровно в этом: выкатить новый микрофронт или
 * перевести существующий на другой адрес можно, не пересобирая хост.
 */
export const REMOTE_MANIFEST_URL = '/remotes.json'

/** Имена ремоутов. Совпадают с полем `name` в их federation-конфигах. */
export const REMOTE_NAMES = {
  /** Лента, профили, подписки. */
  social: 'social',
  /** Спейсы: текстовые каналы и голос — аналог Discord. */
  spaces: 'spaces',
  /** Левая колонка оболочки: рельс серверов и каналы/ЛС в стиле Discord. */
  sidebar: 'sidebar',
  /** Модальное окно настроек пользователя в стиле Discord. */
  settings: 'settings',
} as const

/** Модуль, который каждый ремоут обязан выставлять наружу. */
export const REMOTE_ENTRY_MODULE = './App'

/**
 * Событие закрытия окна настроек.
 *
 * Ремоут `settings` смонтирован — значит открыт (флаг settingsOpen хоста).
 * Попросить закрытие он может только DOM-событием: импортировать стор
 * хоста ремоуту нельзя, `@host/mf` не входит в shared. Хост слушает
 * событие в AppLayout; ремоут переобъявляет строку у себя.
 */
export const SETTINGS_CLOSE_EVENT = 'prismeet:settings:close'
